import React from "react";
import { useSubheader } from "../../../../_metronic/layout";
import { Alert } from "react-bootstrap";
// import GeneralFilter from "../../../components/GeneralFilter";
// import GeneralTable from "../../../components/GeneralTable";
// import { getAllTodayByStatus } from "../../services/casesService";

const Reconsideration = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Reconsideraciones");

  /*const [casesRecord, setCasesRecord] = useState([]);

  const getAllCasesByStatus = () => getAllTodayByStatus("9").then( response => setCasesRecord(response.data) );
  useEffect(() => {
    getAllCasesByStatus();
  }, []);*/
  
  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Reconsideraciones 
      </Alert>
      {/*<GeneralFilter status="9" setCasesRecordState={setCasesRecord} hideAxaCategoryId={true} />*/}

      {/*<GeneralTable data={casesRecord} urlToGo="/reconsideraciones_detalles/" />*/}
    </>
  );
};

export default Reconsideration;
